import React from 'react';
import './SchoolAddress.scss';

const SchoolAddress = ({ name, address }) => {

  return (
    <div className="school-address">
      <div className="college-title-style">{name}</div>
      <div className="college-address-container">
        <div>
          <span>
            {address?.addressLines?.map((line) => (
              <div key={line}>
                <span>{line}</span>
              </div>
            ))}
          </span>
        </div>
        <div>
          <span>
            {address.city}, {address.state}{' '}
          </span>
          <span>
            {address.zipCodeExt ? (
              <span>
                {address.zipCode}-{address.zipCodeExt}
              </span>
            ) : (
              <span>{address.zipCode}</span>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SchoolAddress;
